import { wrapAsDerivedFromMeasurementsConfig as wrap } from '../Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.OversizeCorrectionData.TotalSampleWetMass`]: wrap([
    `${prefix}.OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.ContainerMass`,
    `${prefix}.OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.WetSoilAndContainerMass`,
  ]),
  [`${prefix}.OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.ConstantDrySoilMass`]: wrap([
    `${prefix}.OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.ContainerMass`,
    `${prefix}.OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
  ]),
});

export default getDerivedFromMeasurementsConfig;
